import classNames from 'classnames';
import React from 'react';
import styles from './VideoBlock.module.scss';
import { transformVideoUrl } from './utils';

export interface VideoBlockProps {
  src: string;
  title: string;
  className?: string;
}

export const VideoBlock: React.FC<VideoBlockProps> = ({ src, className, title }) => {
  const transformedSrc = transformVideoUrl(src);

  return (
    <div className={classNames(styles.video_wrapper, className)}>
      <iframe className={styles.video_block} src={transformedSrc} title= loading={'lazy'} />
    </div>
  );
};
